export default __webpack_public_path__ + "static/media/Yenepoya Photos-3.b7297ce4.png";